import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../Icon";

/**
 * <HelpTooltip text="..." /> — ícone de ajuda ("?") que exibe um balão com o
 * texto explicativo ao passar o mouse ou focar. O balão é renderizado via portal
 * no body para nunca ser cortado por containers com overflow.
 */
function HelpTooltip({ text, size = 15 }) {
    const iconRef = useRef(null);
    const [coords, setCoords] = useState({ top: 0, left: 0, below: false });
    const [visible, setVisible] = useState(false);

    const show = () => {
        const el = iconRef.current;
        if (!el) return;

        const rect = el.getBoundingClientRect();
        // Abre acima do ícone; se não houver espaço, abre abaixo.
        const below = rect.top < 140;

        setCoords({
            top: (below ? rect.bottom + 8 : rect.top - 8) + window.scrollY,
            left: rect.left + rect.width / 2 + window.scrollX,
            below,
        });
        setVisible(true);
    };

    const hide = () => setVisible(false);

    useEffect(() => {
        if (!visible) return;
        const onScroll = () => setVisible(false);
        window.addEventListener("scroll", onScroll, true);
        return () => window.removeEventListener("scroll", onScroll, true);
    }, [visible]);

    return (
        <>
            <span
                ref={iconRef}
                className="help-tooltip__trigger"
                tabIndex={0}
                aria-label={text}
                onMouseEnter={show}
                onMouseLeave={hide}
                onFocus={show}
                onBlur={hide}
            >
                <Icon name="help" size={size} />
            </span>
            {visible &&
                createPortal(
                    <span
                        className={`help-tooltip__bubble${coords.below ? " help-tooltip__bubble--below" : ""}`}
                        style={{ top: `${coords.top}px`, left: `${coords.left}px` }}
                        role="tooltip"
                    >
                        {text}
                    </span>,
                    document.body
                )}
        </>
    );
}

export default HelpTooltip;
